import { Icon, LatLngExpression } from "leaflet"
import L from "leaflet"
import { Marker } from "react-leaflet/Marker"

import { getLatLng } from "@/lib/utils"
import { appRoute } from "../routes/app-route"
import { DESTINATION_PIN_SVG, MAP_ASSETS } from "@/config/assets"

const START_ICON = new Icon(MAP_ASSETS.marker.start)
const DESTINATION_ICON = L.divIcon({
  className: "bg-transparent border-none",
  html: DESTINATION_PIN_SVG,
  iconSize: [28, 39],
  iconAnchor: [14, 34],
  popupAnchor: [1, -36],
})

export function MapMarkers() {
  const placeFrom = appRoute.useSearch({ select: (search) => search.from})
  const placeTo = appRoute.useSearch({ select: (search) => search.to})
  const from = placeFrom?.latlng;
  const to = placeTo?.latlng;

  return (
    <>
      <RouteMarker
        marker={{
          position: from,
          icon: START_ICON,
        }}
      />

      {to && (
        <Marker
          position={to}
          icon={DESTINATION_ICON}
        />
      )}
    </>
  )
}

type RouteMarkerProps = {
  marker: {
    icon: Icon
    position?: LatLngExpression
  }
}
export function RouteMarker({ marker }: RouteMarkerProps) {
  if (!marker.position) {
    return
  }

  const latlng = getLatLng(marker.position)
  return (
    <Marker
      position={latlng}
      icon={marker.icon}
    />
  )
}
